import { CSSTransition } from "react-transition-group";
import { useSelector } from "react-redux";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";

import React from "react";
import { currentlyEditingSleeperSelector } from "../../../redux/slices/customNavigation";
import {
  primarySleeperBodyTypeSelector,
  primarySleeperHeightSelector,
  primarySleeperWeightSelector,
  secondarySleeperBodyTypeSelector,
  secondarySleeperHeightSelector,
  secondarySleeperWeightSelector,
} from "../../../redux/slices/mattressConfiguration";
import BigBackgroundText from "../../../components/TextComponents/BigBackgroundText";
import ContainedButton from "../../../components/Buttons/ContainedButton";
import EvrRatioHeightAndWeight from "./EvrRatioHeightAndWeight";
import EvrbedModal from "../../../components/Modal/EvrbedModal";
import GlobalEvrScore from "./GlobalEvrScore";
import MattressBackground from "../../../components/content/MattressBackground";
import mattress_photo from "../../../assets/images/mattress/Layer 0.png";
import svg_background from "../../../assets/images/Path_7821.png";

const BedBuilderContentStep1 = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const primarySleeperHeight = useSelector(primarySleeperHeightSelector);
  const primarySleeperWeight = useSelector(primarySleeperWeightSelector);
  const primarySleeperBodyType = useSelector(primarySleeperBodyTypeSelector);
  const secondarySleeperHeight = useSelector(secondarySleeperHeightSelector);
  const secondarySleeperWeight = useSelector(secondarySleeperWeightSelector);
  const secondarySleeperBodyType = useSelector(
    secondarySleeperBodyTypeSelector
  );

  const currentlyEditingSleeper = useSelector(currentlyEditingSleeperSelector);

  const editingSleeper1 = currentlyEditingSleeper === 1;

  const showPrimaryEvrRatioModal =
    primarySleeperHeight !== "" &&
    primarySleeperWeight !== "" &&
    primarySleeperBodyType !== null;

  const showSecondaryEvrRatioModal =
    secondarySleeperHeight !== "" &&
    secondarySleeperWeight !== "" &&
    secondarySleeperBodyType !== null;

  const showEvrRatioModal = editingSleeper1
    ? showPrimaryEvrRatioModal
    : showSecondaryEvrRatioModal;

  return (
    <MattressBackground showCondition={showEvrRatioModal}>
      {showEvrRatioModal && <GlobalEvrScore />}
      {showEvrRatioModal && <EvrRatioHeightAndWeight />}
    </MattressBackground>
  );
};

export default BedBuilderContentStep1;
